module.exports = {"130525100":"隆尧镇","130525101":"魏家庄镇","130525102":"尹村镇","130525103":"山口镇","130525104":"莲子镇镇","130525105":"固城镇","130525106":"东良镇","130525200":"北楼乡","130525202":"双碑乡","130525203":"牛家桥乡","130525204":"千户营乡","130525205":"大张家庄乡","130525400":"柳行农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130525.json
// module id = 225
// module chunks = 0